import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Logo real de Darwin Optima (la consultoría de reordenamiento empresarial
// de Augusto). El trazo SVG es el mismo que usa darwinoptima.com — se toma
// directo de ahí porque es su propia marca, no un ícono genérico ni el de
// un tercero (a diferencia de Visa/Mastercard, acá no hay ningún tema de
// uso de marca: es su empresa).
const MARK_PATH =
  'M 365 183 A 108.5 108.5 0 1 0 256.5 291.5 L 256.5 183 Z M 256.5 0 A 183 183 0 0 0 256.5 366 L 256.5 331.5 A 148.5 148.5 0 0 1 256.5 34.5 Z M 0 183 A 256.5 256.5 0 0 0 256.5 439.5 L 256.5 405.5 A 222.5 222.5 0 0 1 34 183 Z';

const DarwinOptimaLogo = ({ size = 32, color = '#9CD1CC', textColor, showText = true, sx }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, justifyContent: 'center', ...sx }}>
    <svg width={size} height={size * (440 / 366)} viewBox="0 0 366 440" xmlns="http://www.w3.org/2000/svg">
      <path fill={color} d={MARK_PATH} />
    </svg>
    {showText && (
      <Box sx={{ textAlign: 'left' }}>
        <Typography variant="h6" fontWeight="bold" sx={{ lineHeight: 1.15, color: textColor || 'inherit' }}>
          Darwin Optima
        </Typography>
        <Typography variant="caption" sx={{ letterSpacing: 0.5, opacity: 0.85, display: 'block', color: textColor || 'inherit' }}>
          Order. Precision. Advantage.
        </Typography>
      </Box>
    )}
  </Box>
);

export default DarwinOptimaLogo;
